import { Serializer } from 'jsonapi-serializer';
import { uuidv7 } from 'uuidv7';
import { UserVehicleAssignmentPayload } from '../interfaces/user-vehicle-assignment-payload.interface';

const RELATIONSHIP_TYPES: Record<string, string> = {
	user: 'User',
	vehicle: 'Vehicle',
};

const serializer = new Serializer('UserVehicleAssignment', {
	id: 'id',
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	attributes: ['valid_from', 'user', 'vehicle'],
	typeForAttribute: (attr: string) => RELATIONSHIP_TYPES[attr] ?? attr,
	user: { ref: 'id' },
	vehicle: { ref: 'id' },
	transform(record: UserVehicleAssignmentPayload) {
		return {
			id: uuidv7(),
			valid_from: record.validFrom,
			user: { id: record.userId },
			vehicle: { id: record.vehicleId },
		};
	},
});

export function serializeUserVehicleAssignment(assignment: UserVehicleAssignmentPayload) {
	return serializer.serialize(assignment);
}
